<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="letter-content-create">
                                    Content
                                </label>
                                <textarea
                                    v-model="content"
                                    class="form-control"
                                    id="letter-content-create"
                                    rows="4"
                                    placeholder="Textarea"
                                    disabled
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <label for="letter-content-type">
                                    Type
                                </label>
                                <select
                                    v-model="type"
                                    class="form-control"
                                    id="letter-content-type"
                                    disabled
                                >
                                    <option value="1">Inquiry Letter Content</option>
                                    <option value="2">Inquiry Letter Content Heading</option>
                                    <option value="3">Personal Information Content</option>
                                    <option value="4">Account Content</option>
                                    <option value="5">Footer Sign Off</option>
                                    <option value="6">Footer Content</option>
                                    <option value="7">Letter Content Title</option>
                                    <option value="8">Account Detail Content</option>
                                </select>
                            </div>
                            <router-link
                                :to="{ name: 'list-letter-content' }"
                                v-slot="{ href, route, navigate }"
                            >
                                <button type="button" @click="navigate" class="btn btn-primary">
                                    Back
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import { ref, reactive } from 'vue'
    export default {
        props: {
        },
        setup()
        {
            return {
                content : ref(null),
                type : ref(null),
                baseUrl: baseUrl
            }
        },
        methods:{
        },
        computed: {
        },
        mounted()
        {
            let $this = this,
            props = $this.$router.resolve(
                {
                    name: 'view-letter-content',
                    params: { letter_content: $this.$route.params.letter_content }
                }
            );
            axios.get(
                this.baseUrl + props.path,
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.type = response.data.data.type;
                $this.content = response.data.data.content;
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });            
        }
    }
</script>
